import {Injectable} from '@angular/core'
import {Router} from '@angular/router'

/**
 * Which authentication scheme the current token belongs to.
 *  - `curo`   — legacy opaque token from `POST api://Auth`, sent as
 *               `Authorization: CURO-TOKEN token=<id>`.
 *  - `bearer` — Keycloak/OIDC JWT, sent as `Authorization: Bearer <jwt>`.
 * Both are accepted by the core API, which maps either to the same user.
 */
export type TokenType = 'curo' | 'bearer'

// This helper service stores the token, and last know location,
// and helps with redirects to from the login page
@Injectable()
export class AuthHelperService {
  token: string
  /** Scheme of {@link token}. Defaults to the legacy CURO scheme. */
  tokenType: TokenType = 'curo'

  private loc: string

  constructor(private router: Router) {}

  get location() {
    return this.loc
  }

  public redirect(storeLocation?: string) {
    // store the current url and redirect to the login page
    if (storeLocation !== null) {
      this.loc = storeLocation
    } else {
      // for now we explicitly clear the value
      this.loc = undefined
    }

    this.router.navigate(['/login'])
  }
}
